/* !!!!!!!!!!!!!!!!!!!!!! */
/* !!! GENERATED FILE !!! */
/* !!!!!!!!!!!!!!!!!!!!!! */

import {
  ModuleDoneType,
  ModuleType,
  PlaniraPlanImage,
  type PlaniraTemplate,
} from "../../types";
import { PlanType } from "../../types";
import { PlanTemplateType } from "../template_types";

export const FlowFitnessWorkshopTemplate: PlaniraTemplate = {
  type: PlanTemplateType.FlowFitnessWorkshop,

  planType: PlanType.Quickstart,
  suggestedTitles: [
    "Let’s Get Fit Together!",
    "Fitness Workshop Awaits!",
    "Move and Groove!",
  ],
  title: "Fitness Workshop",
  description: "Organize an engaging fitness workshop.",
  longDescription:
    "Gather your friends for a fun fitness workshop! Choose a date, decide on workout types, and plan activities for the session!",
  emoji: "🏋",
  titleHelp: "Change title or choose another:",
  imageType: PlaniraPlanImage.Woodworker,

  sections: [
    {
      section: {
        isExpandable: false,
        isDraggable: false,
      },
      modules: [
        {
          type: ModuleType.PlanInfo,
          doneType: ModuleDoneType.None,
          title: "Fitness Workshop",
          emoji: "🏋",
        },
      ],
    },
    {
      section: {
        title: "Ongoing",
      },
      modules: [
        {
          type: ModuleType.Calendar,
          doneType: ModuleDoneType.Voting,
          title: "When should we have the fitness workshop?",
          emoji: "📅",
          completeAction: {
            question: "Decide on workout types to try?",
            description:
              "What workout types should we include in the workshop?",
            addModules: [
              {
                type: ModuleType.Poll,
                doneType: ModuleDoneType.Voting,
                title: "What workouts should we consider?",
                emoji: "🏃",
                completeAction: {
                  question: "Decide on refreshments?",
                  description:
                    "What refreshments should we provide after the workshop?",
                  addModules: [
                    {
                      type: ModuleType.Poll,
                      doneType: ModuleDoneType.Voting,
                      title: "What refreshments should we bring?",
                      emoji: "🍉",
                    },
                  ],
                },
              },
            ],
          },
        },
      ],
    },
  ],

  onTemplateComplete: {
    outroTitle: "Let’s Get Fit!",
    outroDescription: "Your fitness workshop plans are set! Enjoy the workout!",
  },
};
